import type { DirectProps, ObjectCSS } from 'quarks/quarkUtils/getDirectProps';
import { getDirectProps } from 'quarks/quarkUtils/getDirectProps';
import type { PseudoClassProps } from 'quarks/quarkUtils/getPseudoClassProps';
import { getPseudoClassProps } from 'quarks/quarkUtils/getPseudoClassProps';
import type { PseudoEleProps } from 'quarks/quarkUtils/getPseudoEleProps';
import { getPseudoEleProps } from 'quarks/quarkUtils/getPseudoEleProps';
import type { ResponsiveProps } from 'quarks/quarkUtils/getResponsiveProps';
import { getResponsiveProps } from 'quarks/quarkUtils/getResponsiveProps';

import type { DefaultTheme, ThemedStyledProps } from 'styled-components';

export const getPropsFromObjectCSS = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: ThemedStyledProps<Record<string, any>, DefaultTheme>,
  objectCSS: ObjectCSS,
) => [
  ...getDirectProps(props, objectCSS, props.theme.palette),
  ...getResponsiveProps(props, objectCSS),
  ...getPseudoClassProps(props, objectCSS),
  ...getPseudoEleProps(props),
];

export type GetAllPropTypes<T extends ObjectCSS> = DirectProps<T> &
  ResponsiveProps<T> &
  PseudoClassProps<T> &
  PseudoEleProps;
